import { defineMessages } from 'react-intl';

export const i18n: {
	commentedByMe: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	commentedByMe: {
		id: 'search-page.filters.names.work-commented-on',
		defaultMessage: "Work I've commented on",
		description: 'Label for filtering for contents commented by the current user',
	},
});
